<template>
  <div>
    <headingComp :heading="'Politica de Privacidade e Politica de Cookies'"/>
    <section class="content-container">
      <div class="sidebar">
        <ol>
          <li @click="scrollTo('.privacidade')">Politica de Privacidade</li>
          <li @click="scrollTo('.cookies')">Politica de Cookies</li>
        </ol>
      </div>
      <div class="container">
        <div class="privacidade">
          <p class="highlight">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Lorem ipsum dolor sit amet Cras sagittis varius velit quis condimentum. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex</p>
        </div>
        <hr>
        <div class="cookies">
          <p class="highlight">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex</p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  name: 'politicas',
  props: [],
  components: {
  },
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
    scrollTo (key) {
      this.$el.querySelector(key).scrollIntoView({behavior: 'smooth'})
    }
  }
}
</script>
<style lang="scss" scoped>
h1 {
  font-size: 80px;
  display: table;
}
h2 {
  font-weight: bold;
  font-size: 36px;
  line-height: 40px;
}
.content-container {
  display: flex;
  margin-top: 125px;
  margin-bottom: 125px;
  flex-wrap: wrap;
  .sidebar {
    width: 15%;
    ol {
      margin-left: 20px;
      li {
        font-size: 24px;
        font-weight: bold;
        padding: 5px 0;
        color: #f6b92f;
        opacity: 0.5;
        cursor: pointer;
      }
      li.active, li:hover {
        opacity: 1;
      }
    }
  }
  .container {
    width: calc(80% - 100px);
    padding: 0 50px;
    .highlight {
      font-weight: bold;
    }
    p {
      line-height: 20px;
      margin-bottom: 20px;
    }
    hr {
      margin: 60px 0;
      border-color: black;
    }
  }
}
</style>